export const PHONE_TYPES = ['Comum', 'WhatsApp']